import React, { useEffect, useState } from 'react'
import * as Yup from 'yup';
import { useFormik } from "formik";
import { DataGrid } from '@mui/x-data-grid';
import dayjs from "dayjs";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import DeleteIcon from '@mui/icons-material/Delete';
import { Autocomplete, IconButton, Chip, FormControlLabel, FormGroup, Checkbox, Typography } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { DatePicker } from '@mui/x-date-pickers';
import { Select, MenuItem, InputLabel, FormHelperText } from '@mui/material';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useNavigate } from 'react-router-dom';
import { getMagneticById, updateMagnetic, createMagnetic, getAutoCertificateNo, deleteMagneticDescription1, getPrint, getMagneticPDF } from "../../../lib/api-magnetic";
import { getAllCustomersAuto } from '../../../lib/api-customer';

import { getAllMaterials } from '../../../lib/api-material';
import { getAllInstruments } from '../../../lib/api-instrument';
import { getAllTechnique } from '../../../lib/api-technique';
import LoadingSpinner from '../../../components/common/LoadingSpinner';
import { Dialog, DialogActions, DialogTitle } from '@mui/material';
import { APP_BASE_PATH } from "../../../lib/api-base-paths";
import CustomSnackbar from "../../../components/common/CustomSnackbar";
import { layoutPrintFormFields } from "../../../utils/printFieldLayout";



const checkboxSelectionToText = (selection, labelMap) => {
  if (!selection) return '';
  if (typeof selection === 'string') {
    try {
      const parsed = JSON.parse(selection);
      if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) {
        selection = parsed;
      } else {
        return selection;
      }
    } catch {
      return selection;
    }
  }
  if (typeof selection !== 'object') return String(selection);
  return Object.entries(selection)
    .filter(([, checked]) => checked)
    .map(([key]) => labelMap[key] || key)
    .join(', ');
};

const srLabelMap = Object.fromEntries(
  Array.from({ length: 12 }, (_, i) => [`option${i + 1}`, String(i + 1)])
);
const typeLabelMap = { option1: '135-A', option2: '146-A' };

const CreateMagnetic = ({ magneticId, isEdit }) => {
  const [cust, setCust] = useState([]);
  const [mate, setMate] = useState([]);
  const [instru, setInstru] = useState([]);
  const [tech, setTech] = useState([]);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [color, setColor] = useState("")
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedValues1, setSelectedValues1] = useState([]);
  const [selectedValues2, setSelectedValues2] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataVersion, setDataVersion] = useState(0);
  const [latestId, setLatestId] = useState(false)
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  const handlePDFModalClose = () => {
    setPdfData(null)
    setOpenPDFModal(false)
  };
  const navigate = useNavigate();
  const handleBack = () => {
    navigate('/Magnetic')
  }
  const [Modals, setModal] = useState({
    option1: false,
    option2: false,
    option3: false,
    option4: false
  });

  const [Sr_Nos, setSrNo] = useState({
    option1: false,
    option2: false,
    option3: false,
    option4: false,
    option5: false,
    option6: false,
    option7: false,
    option8: false,
    option9: false,
    option10: false,
    option11: false,
    option12: false,
  })

  const [Types, setType] = useState({
    option1: false,
    option2: false,
  })

  const [rows, setRows] = useState([]);
  const [formikValues, setFormikValues] = useState({
    Description: '',
    Qty: '',
    Weight: '',
    Accepted: '',
    Rejected: '',
    Remarks: '',
  });
  const [idCounter, setIdCounter] = useState(1);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormikValues(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleAddRow = () => {
    if (!formikValues.Description || !formikValues.Qty || !formikValues.Weight || !formikValues.Accepted || !formikValues.Rejected || !formikValues.Remarks) {
      alert("Please fill in all required fields.");
      return;
    }
    const newRow = { id: idCounter, srNo: idCounter, ...formikValues };
    setIdCounter(idCounter + 1);
    if (rows.length > 0) {
      const maxSrNo = Math.max(...rows.map(row => row.srNo));
      newRow.srNo = maxSrNo + 1;
    } else {
      newRow.srNo = 1;
    }
    newRow.id = newRow.srNo;
    setRows(prevRows => [...prevRows, newRow]);
    setFormikValues({
      Description: '',
      Qty: '',
      Weight: '',
      Accepted: '',
      Rejected: '',
      Remarks: '',
    });
  };

  const handleDelete3 = (id) => {
    deleteMagneticDescription1(id)
      .then(response => {
        console.log(response.data);
        setRows(prevRows => prevRows.filter(row => row.id !== id));
      })
      .catch(error => {
        console.error('Error deleting row:', error);
      });
  };

  const initalValues = {
    Cert_Date: new Date(),
    Certificate_No: '',
    Cust_Name: { value: '', label: '' },
    Referance_Id: '',
    Material_Nm: '',
    Acceptance_Std: 'ASTM.E 709',
    Applicable_Spec: 'ASTM.E 709',
    Scope_Exam: 'All Surface Area',
    Instrument_Use: '',
    Method: '',
    Magnaglo: '',
    Black_Light: '',
    Sr_No: '',
    Intensity: '',
    White_Light: '',
    technician: '',
    Type: '',
    Ampere: '',
    Current: 'A/C-HWDC',
    Batch_No: '',
    Modal: '',
    Demag: '',
    Location: '',
    Witness_By: '',
    Technique: '',
    designation: 'ASNT LEVEL II - UT.MT.PT',
    // New fields
    Exam_Stage: '',
    Procedure_No: '',
    MT_Particle_Type: '',
    Particle_Application: '',
    Carrier: '',
    Particle_Concentration: '',
    Test_Temperature: '',
    Calibration_Date: null,
    Expiry_Date: null,
    Equipment_Range: '',
    Light_Equipment: '',
    Sensitivity_Check: '',
    Equipment_Serial_No: '',
    Gauss_Cal_Date: null,
    Gauss_Cal_Due_Date: null,
  }

  const columns = [
    { field: 'srNo', headerName: 'Sr.No.', flex: 1 },
    { field: 'Description', headerName: 'Description', flex: 1 },
    { field: 'Qty', headerName: 'Qty', flex: 1 },
    { field: 'Weight', headerName: 'Weight', flex: 1 },
    { field: 'Accepted', headerName: 'Accepted', flex: 1 },
    { field: 'Rejected', headerName: 'Rejected', flex: 1 },
    { field: 'Remarks', headerName: 'Remarks', flex: 1 },
    {
      field: 'action', headerName: 'Action', flex: 1,
      renderCell: (params) => (
        <div>
          <IconButton onClick={() => handleDelete3(params.row.id)}>
            <DeleteIcon sx={{ color: 'red' }} />
          </IconButton>
        </div>
      ),
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllCustomersAuto();
        setCust(() => {
          const customerOp = response.map((row) => { return { value: row.Cust_Id, label: row.Cust_Name } });
          return customerOp;
        });
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };
    fetchData();
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllMaterials();
        const materialOp = response.map((row) => { return { value: row.Material_Id, label: row.Material_Nm } });
        setMate(materialOp);
      } catch (error) {
        console.error("Error fetching materials:", error);
      }
    };
    fetchData();
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllInstruments();
        const instrumentOp = response.map((row) => { return { value: row.instrument_id, label: row.Instrument_name } });
        setInstru(instrumentOp);
      } catch (error) {
        console.error("Error fetching instruments:", error);
      }
    };
    fetchData();
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllTechnique();
        const TechniqueOp = response.map((row) => { return { value: row.tech_id, label: row.tech_name } });
        setTech(TechniqueOp);
      } catch (error) {
        console.error("Error fetching Technique:", error);
      }
    };
    fetchData();
  }, [])

  useEffect(() => {
    const fetchCertificateNo = async () => {
      try {
        const getCertificateNo = await getAutoCertificateNo();
        const maxNumber = getCertificateNo.data.nextCertificateNo;
        formik.setFieldValue('Certificate_No', maxNumber);
      } catch (error) { }
    }
    fetchCertificateNo();
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const getMagneticData = await getMagneticById(magneticId);
        setLatestId(true)
        const magneticData = getMagneticData.data.magnetic;

        const [selectedTypeOptions, selectedSr_NoOptions, selectedModalOptions] = await Promise.all([
          JSON.parse(magneticData.Type),
          JSON.parse(magneticData.Sr_No),
          JSON.parse(magneticData.Modal)
        ]);

        setType(selectedTypeOptions);
        setSrNo(selectedSr_NoOptions);
        setModal(selectedModalOptions);

        const parseDate = (dateString) => {
          if (dateString) {
            const parts = dateString.split('/');
            if (parts.length === 3) return `${parts[2]}-${parts[1]}-${parts[0]}`;
            return dateString; // Return as-is if already in YYYY-MM-DD format
          }
          return null;
        };

        const [MaterialValues, TechniqueValues, InstrumentValues] = await Promise.all([
          JSON.parse(magneticData.Material_Test),
          JSON.parse(magneticData.Technique_Test),
          JSON.parse(magneticData.Instrument_Use)
        ]);

        const selectedOptions = MaterialValues.map(value => ({
          value,
          label: mate.find(option => option.value == value)?.label || value
        }));
        setSelectedValues(selectedOptions);

        const selectedOptions1 = TechniqueValues.map(value => ({
          value,
          label: tech.find(option => option.value == value)?.label || value
        }));
        setSelectedValues2(selectedOptions1);

        const selectedOptions2 = InstrumentValues.map(value => ({
          value,
          label: instru.find(option => option.value == value)?.label || value
        }));
        setSelectedValues1(selectedOptions2);

        const CustNew = cust.filter((item) => item.value == magneticData.Cust_Name)[0];

        const sortedData = {
          Cert_Date: parseDate(magneticData.Cert_Date),
          Cust_Name: CustNew,
          Certificate_No: magneticData.Certificate_No,
          Referance_Id: magneticData.Referance_Id,
          Material_Nm: selectedOptions.map((o) => o.label || o.value).join(', '),
          Applicable_Spec: magneticData.Applicable_Spec,
          Acceptance_Std: magneticData.Acceptance_Std,
          Scope_Exam: magneticData.Scope_Exam,
          Method: magneticData.Method,
          Instrument_Use: selectedOptions2.map((o) => o.label || o.value).join(', '),
          Magnaglo: magneticData.Magnaglo,
          Batch_No: magneticData.Batch_No,
          Black_Light: magneticData.Black_Light,
          Modal: selectedModalOptions,
          Sr_No: checkboxSelectionToText(selectedSr_NoOptions, srLabelMap),
          Type: checkboxSelectionToText(selectedTypeOptions, typeLabelMap),
          Intensity: magneticData.Intensity,
          White_Light: magneticData.White_Light,
          Technique: selectedOptions1.map((o) => o.label || o.value).join(', '),
          Ampere: magneticData.Ampere,
          Current: magneticData.Current,
          Demag: magneticData.Demag,
          Witness_By: magneticData.Witness_By,
          technician: magneticData.technician,
          Location: magneticData.Location,
          designation: magneticData.designation,
          // New fields
          Exam_Stage: magneticData.Exam_Stage || '',
          Procedure_No: magneticData.Procedure_No || '',
          MT_Particle_Type: magneticData.MT_Particle_Type || '',
          Particle_Application: magneticData.Particle_Application || '',
          Carrier: magneticData.Carrier || '',
          Particle_Concentration: magneticData.Particle_Concentration || '',
          Test_Temperature: magneticData.Test_Temperature || '',
          Calibration_Date: magneticData.Calibration_Date ? parseDate(magneticData.Calibration_Date) : null,
          Expiry_Date: magneticData.Expiry_Date ? parseDate(magneticData.Expiry_Date) : null,
          Equipment_Range: magneticData.Equipment_Range || '',
          Light_Equipment: magneticData.Light_Equipment || '',
          Sensitivity_Check: magneticData.Sensitivity_Check || '',
          Equipment_Serial_No: magneticData.Equipment_Serial_No || '',
          Gauss_Cal_Date: magneticData.Gauss_Cal_Date ? parseDate(magneticData.Gauss_Cal_Date) : null,
          Gauss_Cal_Due_Date: magneticData.Gauss_Cal_Due_Date ? parseDate(magneticData.Gauss_Cal_Due_Date) : null,
        };

        formik.setValues(sortedData);

        const sortedRows = getMagneticData.data.rows.map((row, index) => ({
          id: row.id,
          srNo: index + 1,
          ...row
        }));
        setRows(sortedRows);
        setLoading(false)
      } catch (error) {
        console.log("Error in Fetching Magnetic Data", error);
      } finally {
        setLoading(false);
      }
    };
    if (isEdit) {
      fetchData();
    }
  }, [isEdit, magneticId, cust, mate, tech, instru, dataVersion]);

  const formik = useFormik({
    initialValues: initalValues,
    validationSchema: Yup.object().shape({
      Cert_Date: Yup.date().notRequired(),
      Certificate_No: Yup.number().notRequired(),
      Cust_Name: Yup.object().notRequired(),
      Referance_Id: Yup.string().notRequired(),
      Material_Nm: Yup.string().notRequired(),
      Acceptance_Std: Yup.string().notRequired(),
      Applicable_Spec: Yup.string().notRequired(),
      Scope_Exam: Yup.string().notRequired(),
      Method: Yup.string().notRequired(),
      Instrument_Use: Yup.string().notRequired(),
      Magnaglo: Yup.string().notRequired(),
      Batch_No: Yup.string().notRequired(),
      Black_Light: Yup.string().notRequired(),
      Technique: Yup.string().notRequired(),
      Intensity: Yup.string().notRequired(),
      White_Light: Yup.string().notRequired(),
      Ampere: Yup.string().notRequired(),
      Current: Yup.string().notRequired(),
      Demag: Yup.string().notRequired(),
      Witness_By: Yup.string().notRequired(),
      technician: Yup.string().notRequired(),
      Location: Yup.string().notRequired(),
      designation: Yup.string().notRequired(),
      // New fields
      Exam_Stage: Yup.string().notRequired(),
      Procedure_No: Yup.string().notRequired(),
      MT_Particle_Type: Yup.string().notRequired(),
      Particle_Application: Yup.string().notRequired(),
      Carrier: Yup.string().notRequired(),
      Particle_Concentration: Yup.string().notRequired(),
      Test_Temperature: Yup.string().notRequired(),
      Calibration_Date: Yup.date().nullable().notRequired(),
      Expiry_Date: Yup.date().nullable().notRequired(),
      Equipment_Range: Yup.string().notRequired(),
      Light_Equipment: Yup.string().notRequired(),
      Sensitivity_Check: Yup.string().notRequired(),
      Equipment_Serial_No: Yup.string().notRequired(),
      Gauss_Cal_Date: Yup.date().nullable().notRequired(),
      Gauss_Cal_Due_Date: Yup.date().nullable().notRequired(),
    }),
    onSubmit: async (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
      try {
        setLoading(true);
        const commaToOptionArray = (val) => {
          if (Array.isArray(val)) return val;
          if (!val) return [];
          return String(val).split(',').map((s) => s.trim()).filter(Boolean)
            .map((s) => ({ value: s, label: s }));
        };
        values.Modal = Modals;
        values.Material_Nm = values.Material_Nm?.trim()
          ? [{ value: values.Material_Nm.trim(), label: values.Material_Nm.trim() }]
          : [];
        values.Technique = commaToOptionArray(values.Technique);
        values.Instrument_Use = commaToOptionArray(values.Instrument_Use);
        let response = {};
        values.rows = rows;
        if (isEdit) {
          response = await updateMagnetic(magneticId, values);
          setConfirmationMessage("Magnetic Updated successfully");
          setIsConfirmationOpen(true);
          setColor('green');
          setDataVersion(v => v + 1);
        } else {
          response = await createMagnetic(values);
          if (response.status == 200) {
            setConfirmationMessage(response.data);
            setIsConfirmationOpen(true);
            setColor('green')
            setLatestId(true);
            resetForm();
            setSelectedValues([]);
            setSelectedValues1([]);
            setSelectedValues2([]);
            setRows([]);
            setType({});
            setSrNo({});
            setModal({});
          } else {
            setConfirmationMessage("Something Went Wrong!");
            setIsConfirmationOpen(true);
            setColor('error')
          }
        }
      } catch (error) {
        setStatus({ success: false });
        setErrors({ submit: error.response?.data?.message });
        setSubmitting(false);
        setLoading(false);
      } finally {
        if (!isEdit) {
          setLoading(false);
        }
      }
    }
  });

  const handleAutocompleteChange1 = (event, value) => {
    formik.setFieldValue('Instrument_Use', value);
    setSelectedValues1(value);
  };

  const handleDelete1 = (valueToDelete) => () => {
    setSelectedValues1((prevValues) =>
      prevValues.filter((value) => value.label !== valueToDelete.label)
    );
  };

  const handleAutocompleteChange2 = (event, value) => {
    formik.setFieldValue('Technique', value);
    setSelectedValues2(value);
  };

  const handleDelete2 = (valueToDelete) => () => {
    setSelectedValues2((prevValues) =>
      prevValues.filter((value) => value.label !== valueToDelete.label)
    );
  };

  const handleAutocompleteChange = (event, value) => {
    setSelectedValues(value);
    formik.setFieldValue('Material_Nm', value);
  };

  const handleDelete = (valueToDelete) => () => {
    setSelectedValues((prevValues) =>
      prevValues.filter((value) => value.label !== valueToDelete.label)
    );
  };

  const handleChangeC = (event) => {
    setModal({ ...Modals, [event.target.name]: event.target.checked });
    formik.setFieldValue('Modal', { ...Modals, [event.target.name]: event.target.checked });
  };

  const handleChangeS = (event) => {
    setSrNo({ ...Sr_Nos, [event.target.name]: event.target.checked });
    formik.setFieldValue('Sr_No', { ...Sr_Nos, [event.target.name]: event.target.checked });
  };

  const handleChangeT = (event) => {
    setType({ ...Types, [event.target.name]: event.target.checked });
    formik.setFieldValue('Type', { ...Types, [event.target.name]: event.target.checked });
  };

  const handlep = () => {
    if (magneticId) {
      handlePrintforedit()
    } else {
      handlePrint()
    }
  }

  const handlePrintforedit = async () => {
    try {
      setLoading(true);
      const getPDF = await getMagneticPDF(magneticId);
      setOpenPDFModal(true);
      const filepath = getPDF.data.returnpath
      setPdfData(filepath);
    } catch (error) {
      console.error("Error while printing:", error);
    } finally {
      setLoading(false);
    }
  }

  const handlePrint = async () => {
    try {
      setLoading(true)
      const response = await getPrint();
      setOpenPDFModal(true);
      const filepath = response.returnpath
      setPdfData(filepath);
    } catch (error) {
      console.error("Error fetching customers:", error);
    } finally {
      setLoading(false)
    }
  }

  // Helper for date pickers in new fields
  const magneticPrintPairs = [
    { left: { name: 'Exam_Stage', label: 'Examination Stage' }, right: { name: 'MT_Particle_Type', label: 'MT Particle Type' } },
    { left: { name: 'Scope_Exam', label: 'Scope of Examination' }, right: { name: 'Particle_Application', label: 'Particle Application' } },
    { left: { name: 'Location', label: 'Location' }, right: { name: 'Batch_No', label: 'Batch No' } },
    { left: { name: 'Acceptance_Std', label: 'Acceptance Standard' }, right: { name: 'Carrier', label: 'Carrier' } },
    { left: { name: 'Applicable_Spec', label: 'Specification' }, right: { name: 'Particle_Concentration', label: 'Particle Concentration' } },
    { left: { name: 'Procedure_No', label: 'Procedure No' }, right: { name: 'Test_Temperature', label: 'Test Temperature' } },
    { left: { name: 'Technique', label: 'MT Technique' }, right: { name: 'Calibration_Date', label: 'Calibration Date', type: 'date' } },
    { left: { name: 'Type', label: 'Equipment Type' }, right: { name: 'Expiry_Date', label: 'Expiry Date', type: 'date' } },
    { left: { name: 'Sr_No', label: 'Equipment Sr. No' }, right: { name: 'Current', label: 'Current Type' } },
    { left: { name: 'Equipment_Range', label: 'Equipment Range' }, right: { name: 'Ampere', label: 'Current (Ampere)' } },
    { left: { name: 'Instrument_Use', label: 'Equipment Make' }, right: { name: 'Light_Equipment', label: 'Light Equipment' } },
    { left: { name: 'Sensitivity_Check', label: 'Sensitivity Check' }, right: { name: 'Intensity', label: 'Light Intensity' } },
    { left: { name: 'Demag', label: 'Demagnetization' }, right: { name: 'Equipment_Serial_No', label: 'Equipment Serial No' } },
    { left: { name: 'Gauss_Cal_Date', label: 'Gauss Meter Calibration Date', type: 'date' }, right: { name: 'Gauss_Cal_Due_Date', label: 'Gauss Meter Calibration Due Date', type: 'date' } },
  ];

  const renderMagneticPrintField = (field) => {
    const key = field.reactKey || field.name;
    if (field.type === 'date') {
      return (
        <LocalizationProvider key={key} dateAdapter={AdapterDayjs}>
          <DatePicker
            label={field.label}
            format="DD/MM/YYYY"
            value={formik.values[field.name] ? dayjs(formik.values[field.name]) : null}
            onChange={(date) => formik.setFieldValue(field.name, date ? dayjs(date).format('YYYY-MM-DD') : null)}
            slotProps={{ textField: { fullWidth: true, variant: 'outlined' } }}
          />
        </LocalizationProvider>
      );
    }
    return (
      <TextField
        key={key}
        fullWidth
        label={field.label}
        name={field.name}
        variant="outlined"
        value={formik.values[field.name] ?? ''}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
    );
  };

  return (
    <div>
      {loading && <LoadingSpinner />}
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: "0.5rem" }}>
          <FormControl style={{ width: "180px" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                name="Cert_Date"
                format="DD/MM/YYYY"
                label="Date"
                errors={formik.errors}
                value={formik.values.Cert_Date ? dayjs(formik.values.Cert_Date) : null}
                onChange={(date) => {
                  formik.setFieldValue(
                    "Cert_Date",
                    date ? dayjs(date).format('YYYY-MM-DD') : dayjs(formik.values.assignedDate).format('YYYY-MM-DD') || null
                  );
                }}
              />
            </LocalizationProvider>
          </FormControl>
          <TextField
            style={{ width: "37.5vw" }}
            id="outlined-basic"
            label="Certificate No."
            variant="outlined"
            name='Certificate_No'
            error={formik.errors.Certificate_No && formik.touched.Certificate_No}
            helperText={formik.touched.Certificate_No ? formik.errors.Certificate_No : ''}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values.Certificate_No}
          />
        </div>
        <div>
          <Autocomplete
            options={cust}
            getOptionLabel={(option) => option.label}
            onChange={(event, value) => formik.setFieldValue('Cust_Name', value || null)}
            value={formik.values.Cust_Name}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{ width: "50vw" }}
                label="Customer Name"
                variant="outlined"
                name="Cust_Name"
                error={formik.errors.Cust_Name && formik.touched.Cust_Name}
                helperText={formik.touched.Cust_Name ? formik.errors.Cust_Name : ''}
                onBlur={formik.handleBlur}
              />
            )}
          />
        </div>
        <div>
          <TextField
            style={{ width: "50vw" }}
            id="outlined-basic"
            label="Reference"
            name='Referance_Id'
            variant="outlined"
            error={formik.errors.Referance_Id && formik.touched.Referance_Id}
            helperText={formik.touched.Referance_Id ? formik.errors.Referance_Id : ''}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values.Referance_Id}
          />
        </div>
      </div>

      <br />
      <div>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', columnGap: '1%' }}>
            <TextField id="outlined-basic" label="Part Description" name="Description" variant="outlined" style={{ width: '10vw' }} onChange={handleChange} value={formikValues.Description} />
            <TextField id="outlined-basic" label="Qty" name="Qty" variant="outlined" style={{ width: '10vw' }} onChange={handleChange} value={formikValues.Qty} />
            <TextField id="outlined-basic" label="Weight" name="Weight" variant="outlined" style={{ width: '10vw' }} onChange={handleChange} value={formikValues.Weight} />
            <TextField id="outlined-basic" label="Accepted" name="Accepted" variant="outlined" style={{ width: '10vw' }} onChange={handleChange} value={formikValues.Accepted} />
            <TextField id="outlined-basic" label="Rejected" name="Rejected" variant="outlined" style={{ width: '10vw' }} onChange={handleChange} value={formikValues.Rejected} />
            <TextField id="outlined-basic" label="Remarks" name='Remarks' variant="outlined" style={{ width: "10vw" }} onChange={handleChange} value={formikValues.Remarks} />
            <Button onClick={handleAddRow} style={{ backgroundColor: "red", color: "white" }} variant="contained">Add</Button>
          </div>
          <div style={{ marginBlock: "20px" }}>
            <DataGrid
              autoHeight
              density="compact"
              rows={rows}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5, 10, 20]}
            />
          </div>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "2rem", marginTop: "3vh" }}>
        {layoutPrintFormFields(magneticPrintPairs.map((p) => p.left), []).map(renderMagneticPrintField)}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "2rem", marginTop: "2rem", marginBottom: "3vh" }}>
        {layoutPrintFormFields([], magneticPrintPairs.map((p) => p.right)).map(renderMagneticPrintField)}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: "2rem", marginBottom: "3vh" }}>
        {/* <TextField fullWidth label="Material Name" name="Material_Nm" variant="outlined"
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.Material_Nm} />
        <TextField fullWidth label="Method" name="Method" variant="outlined"
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.Method} />
        <TextField fullWidth label="Magnaglo" name="Magnaglo" variant="outlined"
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.Magnaglo} />
        <TextField fullWidth label="Black Light" name="Black_Light" variant="outlined"
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.Black_Light} />
        <TextField fullWidth label="White Light Intensity" name="White_Light" variant="outlined"
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.White_Light} /> */}
        <TextField fullWidth label="Witness By" name="Witness_By" variant="outlined"
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.Witness_By} />
        <TextField fullWidth label="Technician" name="technician" variant="outlined"
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.technician} />
        <TextField fullWidth label="Designation" name="designation" variant="outlined"
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.designation} />
        {/* <div>
          <InputLabel id="modal-checkbox">Modal</InputLabel>
          <FormGroup id="modal-checkbox">
            <FormControlLabel control={<Checkbox checked={Modals.option1} onChange={handleChangeC} name="option1" />} label="1500 AC" />
            <FormControlLabel control={<Checkbox checked={Modals.option2} onChange={handleChangeC} name="option2" />} label="1500 HWDC/AC" />
            <FormControlLabel control={<Checkbox checked={Modals.option3} onChange={handleChangeC} name="option3" />} label="CD-1250" />
            <FormControlLabel control={<Checkbox checked={Modals.option4} onChange={handleChangeC} name="option4" />} label="HWDC" />
          </FormGroup>
        </div> */}
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button onClick={handlep} style={{ backgroundColor: latestId ? "orange" : "gray", color: "white", marginInline: "0.7rem", opacity: latestId ? 1 : 0.5 }} disabled={!latestId}>PRINT</Button>
        <Button onClick={formik.handleSubmit} style={{ backgroundColor: "Green", color: "white", marginInline: "0.7rem" }}>
          {magneticId === undefined ? "Save" : "Update"}
        </Button>
        <Button onClick={handleBack} style={{ backgroundColor: "red", color: "white", marginInline: "0.7rem" }}>CANCEL</Button>
        <Button onClick={handleBack} style={{ backgroundColor: "blue", color: "white" }}>BACK</Button>
      </div>

      <Dialog open={openPDFModal} onClose={handlePDFModalClose} aria-labelledby="alert-dialog-title" maxWidth={1200}>
        <DialogTitle>Invoice</DialogTitle>
        <iframe title="pdf-view" src={pdfData ? `${APP_BASE_PATH}${pdfData}` : null} width="800px" height="800px"></iframe>
        <DialogActions>
          <Button onClick={handlePDFModalClose}>Close</Button>
        </DialogActions>
      </Dialog>

      <CustomSnackbar
        open={isConfirmationOpen}
        message={confirmationMessage}
        color={color}
        onClose={() => setIsConfirmationOpen(false)}
      />
    </div>
  )
}

export default CreateMagnetic;